import { ChangeEvent } from 'react';
import { Box, Card } from '@nimbus-ds/components';
import { FormField } from '@nimbus-ds/patterns';
import { useAutoFocus } from 'commons/hooks';
import { useTranslationMarketing } from 'domains/Marketing/hook';
import { PromotionFormProps } from '../PromotionForm';

interface NameCardProps
  extends Pick<PromotionFormProps, 'values' | 'onChange'> {
  disabled: boolean;
}

// Regex to allow only Latin-1 characters (includes basic letters, digits, punctuation, and symbols)
const VALID_NAME_REGEX = /^[\u0020-\u007E\u00A0-\u00FF]*$/;

export function NameCard({
  values: { name },
  disabled,
  onChange,
}: Readonly<NameCardProps>) {
  const t = useTranslationMarketing('promotions.settingsPage');

  const { ref } = useAutoFocus();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (VALID_NAME_REGEX.test(newValue) || newValue === '') {
      onChange(e);
    }
  };

  return (
    <Card>
      <Card.Header title={t('name')} />
      <Card.Body>
        <Box
          display="flex"
          flexDirection="column"
          gap="3"
          marginBottom="1"
          ref={ref}
        >
          <FormField.Input
            name="name"
            value={name}
            onChange={handleChange}
            showHelpText
            helpText={t('info')}
            disabled={disabled}
          />
        </Box>
      </Card.Body>
    </Card>
  );
}
